"use client";

import { useEffect, useState } from "react";
import { fetchSessionUser, mightHaveAuthSession } from "@/lib/authClient";
import { canCreateGalleryContent } from "@/lib/galleryAccess";

export function useSessionNav() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [showGallery, setShowGallery] = useState(false);
  const [canCreateGallery, setCanCreateGallery] = useState(false);

  useEffect(() => {
    let alive = true;

    async function refresh() {
      if (!mightHaveAuthSession()) {
        if (alive) {
          setIsAdmin(false);
          setShowGallery(false);
          setCanCreateGallery(false);
        }
        return;
      }
      try {
        const user = await fetchSessionUser({ clearStale: true });
        if (alive) {
          setIsAdmin(user?.role === "admin");
          setShowGallery(Boolean(user?.section));
          setCanCreateGallery(canCreateGalleryContent(user));
        }
      } catch {
        if (alive) {
          setIsAdmin(false);
          setShowGallery(false);
          setCanCreateGallery(false);
        }
      }
    }

    void refresh();

    const onStorage = (e: StorageEvent) => {
      if (e.key === "logout" || e.key === "auth_session") void refresh();
    };
    const onAuthChanged = () => void refresh();

    window.addEventListener("storage", onStorage);
    window.addEventListener("auth:changed", onAuthChanged);

    return () => {
      alive = false;
      window.removeEventListener("storage", onStorage);
      window.removeEventListener("auth:changed", onAuthChanged);
    };
  }, []);

  return { isAdmin, showGallery, canCreateGallery };
}

export function useIsAdmin() {
  return useSessionNav().isAdmin;
}